<template lang="pug">
  .dashboard-products(v-if="products.length != 0")
    v-card.mx-3.pa-4(flat outlined style="border: 1px solid var(--v-primary200);")
      h6.basic1000--text {{ $t('stock_up_soon') }}
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      .products-content(v-else)
        v-layout.my-6(v-if="products.length == 0")
          v-row.fill-height.ma-0(align='center' justify='center')
            div.mx-auto
              v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
              p.caption {{ $t('looking_good') }}
        v-list(subheader)
          v-list-item.px-0(v-for='product in products' :key='product.id')
            v-list-item-avatar(size=40)
              v-img(:src="product.image ? product.image.file : require('@/assets/image_placeholder.png')")
            v-list-item-content
              v-list-item-title.s1.basic800--text(v-text='product.display_name')
              v-list-item-subtitle
                v-layout
                  .c1.basic600--text {{ product.price | displayPrice }}
                  v-spacer
                  .c1.danger500--text(v-if="product.inventory_qty <= 0") {{ product.inventory_qty }} {{ $t('left_in_stock') }}
                  .c1.warning500--text(v-else-if="product.inventory_qty <= 5") {{ product.inventory_qty }} {{ $t('left_in_stock') }}
                  .c1.textColorHint--text(v-else) {{ product.inventory_qty }} {{ $t('left_in_stock') }}
      v-layout.mt-4
        v-btn(color='info500' block dark depressed height=32 @click="$router.push('/admin/products-inventory')")
          .button-AA-small.basic100--text {{ $t('manage_inventory') }}

</template>

<script>

export default {
  name: 'DashboardProducts',
  props: ['company'],
  data: () => ({
    isFetching: true,
    products: []
  }),
  mounted () {
    this.$axios.get(`/products/?page=1&page_size=3&company=${this.company.id}&inventory_enabled=true&include_sub_product=true&ordering=inventory_qty&inventory_qty_max=10`).then((response) => {
      this.products = response.data.results
    })
    .catch(() => {})
    .finally(() => {
      this.isFetching = false
    })
  }
}
</script>

<style scoped>
</style>